export const templateState = (state = {}, action) => {
  if (action.type === 'UPDATE_TEMPLATE') {
    const newState = { ...state, ...action.templateState };

    return newState;
  }

  return state;
};
